class SocialShare {
    constructor() {
        this.initEvents();
    }

    initEvents() {
        // `.social-buttons` 내의 각 버튼을 찾습니다.
        // 버튼이 존재하지 않는 경우, `parentNode`에 접근하려고 시도하기 전에 `null`을 반환합니다.
        const linkedInIcon = document.querySelector('.social-buttons .fa-linkedin-in');
        const facebookIcon = document.querySelector('.social-buttons .fa-facebook-f');
        const shareBtn = document.querySelector('.social-buttons .share-btn');

        // `.parentNode` 접근 전에 해당 아이콘이 존재하는지 확인합니다.
        const linkedInBtn = linkedInIcon ? linkedInIcon.parentNode : null;
        const facebookBtn = facebookIcon ? facebookIcon.parentNode : null;
        
        // LinkedIn과 Facebook 공유 이벤트 리스너 설정
        // 이제 요소가 실제로 존재할 때만 이벤트 리스너를 추가합니다.
        if (linkedInBtn) {
            linkedInBtn.addEventListener('click', SocialShare.shareToLinkedIn);
        }
        
        if (facebookBtn) {
            facebookBtn.addEventListener('click', SocialShare.shareToFacebook);
        }

        // SHARE 버튼 이벤트 리스너 설정
        // `shareBtn`도 마찬가지로 존재할 때만 이벤트 리스너를 추가합니다.
        if (shareBtn) {
            shareBtn.addEventListener('click', () => this.handleShare());
        }
    }

    static shareToLinkedIn() {
        const url = encodeURIComponent(window.location.href);
        const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
        window.open(shareUrl, "_blank");
    }

    static shareToFacebook() {
        const url = encodeURIComponent(window.location.href);
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        window.open(shareUrl, "_blank");
    }

    handleShare() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                url: window.location.href,
            }).then(() => console.log('Successful share'))
            .catch((error) => console.log('Error sharing', error));
        } else {
            this.showCopyPopup(window.location.href);
        }
    }

    showCopyPopup(url) {
        navigator.clipboard.writeText(url).then(() => {
            alert("URL copied to clipboard!");
        }).catch(err => {
            console.error('Failed to copy: ', err);
            prompt("Copy this URL to share:", url);
        });
    }
}

export default SocialShare;
